import React from 'react';
import Loadable from 'react-loadable';
import LoadableLoading from 'components/LoadableLoading';
import { getDefectActBrandAvailableColumns } from './api';

export const path = '/defect-act-brand/list';

const PageDefectActBrandList: React.FC = (props) => {
  const DefectActBrand = Loadable.Map({
    loader: {
      page: () => import('./page'),
      columns: getDefectActBrandAvailableColumns,
    },
    loading: LoadableLoading,
    render(loaded, loadedProps: {}) {
      const Page = loaded.page.default;

      return <Page {...loadedProps} {...loaded} />;
    },
  });

  return <DefectActBrand {...props} />;
};

export default PageDefectActBrandList;
